import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

import { renderDateRange } from "../helpers/formComponent";
const mapStateToProps = state => ({
  state
});

class AccountingDocuments extends Component {
  state = {
    closeNotice: true,
    updateDate: true,
    warningLength: false,
    warningFilms: false
  };

  componentDidMount = () => {
    const { addFilms } = this.state;
    if ((addFilms || []).length === 0) {
      this.setState({ warningFilms: true });
    }
  };

  componentDidUpdate(prevProps) {
    const nextProps = this.props;
    if (prevProps !== nextProps) {
      const { form: storeForm } = prevProps.state;
      const form = storeForm.AccountingDocuments;
      if (form) {
        const { updateDate } = this.state;

        //Записываем данные времени в форму
        if (updateDate) {
          form["values"] = {
            date: new Date().mmddyyyy() + "-" + new Date().mmddyyyy()
          };
        }

        const [dateBegin, dateEnd] = form.values.date.split("-");
        // const dtBegin = new Date(yyyymmdd(new Date(dateBegin)));
        // const dtEnd = new Date(yyyymmdd(new Date(dateEnd)));
        const rangeTS =
          new Date(dateBegin).getTime() - new Date(dateEnd).getTime();

        this.setState({ warningLength: rangeTS / 1000 / 3600 / 24 + 1 > 7 });
      }
    }
  }

  generate = type => {
    let data = this.props.state.form.AccountingDocuments.values.date;
    console.log("Отправляем запрос на ", type, "date: " + data);
  };

  closeWarningClick = () => {
    this.setState({
      warningFilms: false
    });
  };

  closeWarningLengthDayClick = () => {
    this.setState({
      warningLength: false
    });
  };

  generateDocumentClick = () => {
    this.generate("document");
  };

  generateActClick = () => {
    this.generate("act");
  };

  render() {
    const { date, warningFilms, warningLength } = this.state;
    return (
      <Fragment>
        <h1 className="office-h1">Отчетные документы</h1>
        <div className="office-docs">
          <div className="office-docs__input-group">
            <div className="custom-datepicker__group">
              <Field
                type="text"
                name="date"
                component={renderDateRange}
                className="custom-datepicker__input"
                id="session-datepicker"
                singleDatePicker={false}
                date={date}
              />
            </div>
            <button
              onClick={this.generateDocumentClick}
              className="btn-gradient"
            >
              Сформировать документы
            </button>
            <button onClick={this.generateActClick} className="btn-gradient">
              Сформировать акт сверки
            </button>
          </div>

          {/* Предупреждения */}
          {warningFilms && (
            <div className="notice-block">
              <div className="notice-block__icon">i</div>
              <div className="notice-block__description">
                Перед заполнением отчетов <br /> необходимо заполнить расписание
              </div>
              <div
                onClick={this.closeWarningClick}
                className="notice-block__hide"
              >
                Скрыть
              </div>
            </div>
          )}
          {warningLength && (
            <div className="notice-block">
              <div className="notice-block__icon">i</div>
              <div className="notice-block__description">
                Указан период более недели
              </div>
              <div
                onClick={this.closeWarningLengthDayClick}
                className="notice-block__hide"
              >
                Скрыть
              </div>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

const form = reduxForm({
  form: "AccountingDocuments",
  destroyOnUnmount: true
})(AccountingDocuments);

export default connect(
  mapStateToProps
)(form);



// WEBPACK FOOTER //
// ./src/containers/AccountingDocuments.jsx